import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Notification.sass';
import { CSSTransition } from 'react-transition-group';

class Notification extends Component {
	render() {
		const { isOpen, notification, onNotificationClose } = this.props;
		return (
			<CSSTransition
				in={isOpen}
				timeout={100}
				classNames="notification-dimmer"
				unmountOnExit
			>
				{state => (
					<div className="notification-dimmer">
						<CSSTransition
							in={state === 'entered'}
							timeout={100}
							classNames="notification-wrap"
							unmountOnExit
						>
							<div className="notification-wrap">
								<p className="notification-message">
									{notification}
								</p>
								<div className="notification-controls">
									<button
										className="ui-button ui-button-primary ui-button-tiny"
										onClick={onNotificationClose}
									>
										OK
									</button>
								</div>
							</div>
						</CSSTransition>
					</div>
				)}
			</CSSTransition>
		);
	}
}

Notification.propTypes = {
	isOpen: PropTypes.bool,
	notification: PropTypes.string,
	onNotificationClose: PropTypes.func,
};

export default Notification;
